import{m as e}from"./ninox-components-2ADN25D5.js";import{k as i}from"./ninox-components-R4FVH3NU.js";import{a as t}from"./ninox-components-I2GBTDK4.js";import n from"styled-components";var s=n.header`
    position: sticky;
    top: 0;
    z-index: 1;

    flex-shrink: 0;
    padding: ${e.x_small} ${e.small} ${e.xxx_small};

    color: ${({theme:o})=>o.text.secondary};
    background-color: ${({theme:o})=>o.popup.backgroundColor};
    border-radius: inherit;

    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-transform: uppercase;

    font-size: ${i.x_small};
    font-weight: ${t.semibold};
    letter-spacing: ${e.thin};
    line-height: 1.5;

    &:empty {
        display: none;
    }
`;export{s as a};
//# sourceMappingURL=ninox-components-UM7ABPXQ.js.map